<script setup>
</script>

<template>
  <div class="cloud-calculator__param">
    <p class="cloud-calculator__param-title">
      <slot name="title"/>
    </p>
    <p v-if="$slots.subtitle" class="cloud-calculator__param-subtitle">
      <slot name="subtitle"/>
    </p>
    <slot/>
    <slot name="information"/>
  </div>
</template>
